import { render, staticRenderFns } from "./AgGridTable.vue?vue&type=template&id=24366af4&scoped=true"
import script from "./AgGridTable.vue?vue&type=script&lang=js"
export * from "./AgGridTable.vue?vue&type=script&lang=js"
import style0 from "./AgGridTable.vue?vue&type=style&index=0&id=24366af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24366af4",
  null
  
)

export default component.exports